import _ from 'lodash';
import * as types from '@/store/mutation-types';

const state = {
  notifications: [],
};

const getters = {
  notifications(state) {
    return state.notifications;
  },
};

const mutations = {
  [types.ADD_NOTIFICATION](state, payload) {
    // splice arrays to the top of the array, so new items show on top in the template
    state.notifications.splice(0, 0, payload);
  },
  [types.REMOVE_NOTIFICATION](state, payload) {
    state.notifications.splice(payload, 1);
  },
};

const actions = {
  // payload example to dispatch
  // {
  //   id: guid(),
  //   type: 'success', // string
  //   message: 'string', // string
  //   action: 'optional', // string
  //   actionFn: // function
  // }
  async addNotification({ state, commit }, notification) {
    await commit(types.ADD_NOTIFICATION, notification);
    if (notification.type === 'success') {
      setTimeout(() => {
        const i = _.findIndex(state.notifications, o => o.id === notification.id);
        commit(types.REMOVE_NOTIFICATION, i);
      }, notification.time || 2000);
    }
  },
  removeNotification: ({ commit }, notification) => {
    commit(types.REMOVE_NOTIFICATION, notification);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/global-view/notifications/vuex.js